import { faLessThanEqual } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";

import { Col, Row } from 'reactstrap';

function Rango({
    value,
    onChange,
    fechaInicioMinimoDias,
    fechaRangoMaximoDias,
    validationCallback
}) {
    const [selectionRange, setSelectionRange] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });

    const [tieneError, setTieneError] = useState(false)
    const [mensajeError, setMensajeError] = useState(false)


    const handleSelectStart = (date) => {
        var cloneValue = { ...selectionRange }

        cloneValue.startDate = date
        setSelectionRange(cloneValue)
        onChange(cloneValue)


    };

    const handleSelectEnd = (date) => {
        var cloneValue = { ...selectionRange }

        cloneValue.endDate = date
        setSelectionRange(cloneValue)
        onChange(cloneValue)

    };



    useEffect(() => {

        console.log('valueee', value)



        if (value) {

            const startDate = moment(value.startDate);
            const endDate = moment(value.endDate);

            // Validar si endDate es mayor que startDate
            if (endDate.isAfter(startDate)) {
                // Calcular la diferencia en años
                const yearsDifference = endDate.diff(startDate, 'days');

                console.log('yearsDifference', yearsDifference)

                // Validar si la diferencia es de máximo un año
                if (yearsDifference < fechaRangoMaximoDias) {

                    const diferenciaInicio = startDate.diff(new Date(), 'days');

                    if (diferenciaInicio < fechaInicioMinimoDias) {
                        setTieneError(true)
                        setMensajeError(`La fecha de inicio debe ser como mínimo ${fechaInicioMinimoDias} día(s) posterior a la fecha actual`)
                        validationCallback(true)
                    } else {

                        setTieneError(false)
                        setMensajeError('')
                        validationCallback(false)

                    }




                } else {
                    setTieneError(true)
                    setMensajeError(`La fecha de finalización debe ser como máximo ${fechaRangoMaximoDias} día(s) posterior a la fecha de inicio`)
                    validationCallback(true)
                }
            } else {

                setTieneError(true)
                setMensajeError('La fecha de finalización debe ser posterior a la fecha de inicio')
                validationCallback(true)

            }

        } else {

            setTieneError(true)
            setMensajeError('Seleccione el rango de fechas ')
            validationCallback(true)

        }



    }, [value]);




    return (
        <div style={{marginLeft:15}}>

            <Row style={{ width: '450px' }}>
                <Col md={6}>
                    <div style={{}}>
                        <Row>
                            <small>
                                Fecha inicio
                            </small>
                        </Row>

                        <Row>
                            <DatePicker

                                dateFormat="dd/MM/yyyy"
                                isClearable={false}
                                selected={value ? new Date(value.startDate) : selectionRange.startDate}
                                onChange={(valor) => {
                                    handleSelectStart(valor)
                                }}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control"

                            />

                        </Row>

                    </div>

                </Col>

                <Col md={6}>
                    <div style={{}}>
                        <Row>
                            <small>
                                Fecha fin
                            </small>
                        </Row>

                        <Row>
                            <DatePicker

                                dateFormat="dd/MM/yyyy"
                                isClearable={false}
                                selected={value ? new Date(value.endDate) : selectionRange.endDate}
                                onChange={(valor) => {
                                    handleSelectEnd(valor)
                                }}
                                peekNextMonth
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                className="form-control"

                            />
                        </Row>

                    </div>

                </Col>
                {tieneError &&
                    <small style={{ color: 'red' }}>{mensajeError}</small>
                }
            </Row>

        </div>
    );
}

export default Rango;
